<template>
    <div class="row mtn-30">
        <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
            <div class="fun-fact--one mt-30 text-center">
                <h5 class="fun-fact__title">Installed</h5>
                <div class="fun-fact__count counter">
                    <span>+300</span>
                </div>
                <span class="fun-fact__text">kW Solar</span>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
            <div class="fun-fact--one mt-30 text-center">
                <h5 class="fun-fact__title">Operating</h5>
                <div class="fun-fact__count counter">
                    <span>+2000</span>
                </div>
                <span class="fun-fact__text">days</span>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
            <div class="fun-fact--one mt-30 text-center">
                <h5 class="fun-fact__title">Retrofitted</h5>
                <div class="fun-fact__count counter">
                    <span>+400</span>
                </div>
                <span class="fun-fact__text">systems</span>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
            <div class="fun-fact--one mt-30 text-center">
                <h5 class="fun-fact__title">Monitoring</h5>
                <div class="fun-fact__count counter">
                    <span>+10</span>
                </div>
                <span class="fun-fact__text">sites</span>
            </div>
        </div>
    </div>
</template>
